import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { useVirtualGrid } from '../VirtualGrid/useVirtualGrid.js';
import { useInViewWithinRadixScrollArea } from '../ScrollArea.js';

const VirtualDataTable = ({ data, columns, args, className, RowComponent, virtualConfig, minWidth, children, hideHeader, HeaderComponent }) => {
  const R = RowComponent || VirtualTableRow;
  const containerRef = useRef(null);
  const isInView = useInViewWithinRadixScrollArea(containerRef);
  const { getVirtualItems, containerDimensions } = useVirtualGrid({
    columnCount: 1,
    scrollElement: containerRef.current?.closest("[data-radix-scroll-area-viewport]"),
    scrollArea: containerRef.current?.closest("[data-radix-scroll-area-viewport]")?.parentElement,
    ...virtualConfig,
    enabled: isInView
  });
  const Header = HeaderComponent || VirtualTableRow;
  return /* @__PURE__ */ jsxs("div", {
    "data-vdt": true,
    className,
    ref: containerRef,
    style: {
      /**
      * we need to add extra height for the header which is not included
      * in the items count
      */
      height: containerDimensions.height + (hideHeader ? 0 : virtualConfig.itemHeight),
      width: containerDimensions.width,
      minWidth
    },
    children: [
      children,
      !hideHeader && /* @__PURE__ */ jsx(Header, {
        "data-vdt-header": true,
        args,
        children: columns.map(({ HeaderCellComponent, id }, colIndex) => {
          return /* @__PURE__ */ jsx("div", {
            "data-vdt-header-cell": colIndex,
            "data-vdt-item-col-id": id,
            children: /* @__PURE__ */ jsx(HeaderCellComponent, {
              colId: id,
              colIndex,
              args
            })
          }, colIndex);
        })
      }),
      getVirtualItems().map((virtualItem) => {
        const dataItem = data[virtualItem.index];
        const rowIndex = virtualItem.index;
        const style = {
          position: "absolute",
          transform: `translate3d(${virtualItem.startX}px, ${virtualItem.startY}px, 0px)`,
          width: "100%"
        };
        return /* @__PURE__ */ jsx(R, {
          data: dataItem,
          rowIndex,
          "data-vdt-row": rowIndex,
          style,
          children: columns.map(({ CellComponent, CellSkeletonComponent, id }, colIndex) => {
            return /* @__PURE__ */ jsx("div", {
              "data-vdt-item-col": colIndex,
              "data-vdt-item-row": virtualItem.index,
              "data-vdt-item-col-id": id,
              children: !dataItem ? /* @__PURE__ */ jsx(CellSkeletonComponent, {}, `${rowIndex}--${colIndex}`) : /* @__PURE__ */ jsx(CellComponent, {
                args,
                data: dataItem,
                colIndex,
                rowIndex
              })
            }, colIndex);
          })
        }, rowIndex);
      })
    ]
  });
};
const VirtualTableRow = styled.div.withConfig({
  displayName: "VirtualDataTable__VirtualTableRow",
  componentId: "sc-c26344e1-0"
})([
  `display:flex;flex-direction:row;align-items:center;justify-content:flex-start;`
]);

export { VirtualDataTable, VirtualTableRow };
//# sourceMappingURL=VirtualDataTable.js.map
